/**
 * Centralized enums for application stages & statuses.
 * Change values here to update behavior across the app.
 */

export const APP_STAGES = {
  APP_CREATION: "App Creation",
  POST_SANCTION: "Post Sanction",
  DISBURSEMENT: "Disbursement",
};

export const APP_STATUSES = {
  DISBURSEMENT_REQUEST_PENDING: "Disbursement Request Pending",
};

/**
 * Stages where the disbursement-request screen should be read-only
 * (no uploads, no initiate). Add stages here to extend the lock.
 */
export const READ_ONLY_STAGES = [APP_STAGES.DISBURSEMENT];

/**
 * True when the application is in a stage where write actions
 * (document upload, initiate disbursement, etc.) must be disabled.
 */
export const isReadOnlyStage = (stage) =>
  !!stage && READ_ONLY_STAGES.includes(stage);

/**
 * Products that should display the app_current_stage badge on application cards.
 * Add product codes here to enable the stage badge for additional products.
 */
export const PRODUCTS_WITH_STAGE_BADGE = new Set([
  "RTS_MICRO_CNI",
]);

/**
 * True when the app_current_stage badge should be shown for the given application.
 */
export const shouldShowStageBadge = (application) =>
  !!application?.app_current_stage &&
  !!application?.product?.product_short_name &&
  PRODUCTS_WITH_STAGE_BADGE.has(application.product.product_short_name);

/**
 * True when the "Disbursement" action button should be visible
 * on the Applications list for an application.
 */
export const canShowDisbursementAction = (application) =>
  application?.app_current_stage === APP_STAGES.POST_SANCTION &&
  application?.app_current_status === APP_STATUSES.DISBURSEMENT_REQUEST_PENDING &&
  !!(
    application?.lead?.sourcing_channel_contact_name ||
    application?.lead?.sourcing_channel_contact_phone ||
    application?.lead?.sourcing_channel_contact_email
  );
